import { render, staticRenderFns } from "./MobileMenuCatalog.vue?vue&type=template&id=a8491c46&scoped=true&"
import script from "./MobileMenuCatalog.vue?vue&type=script&lang=js&"
export * from "./MobileMenuCatalog.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuCatalog.vue?vue&type=style&index=0&id=a8491c46&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8491c46",
  null
  
)

export default component.exports